import { render, staticRenderFns } from "./footer-user.vue?vue&type=template&id=faf5c618&scoped=true&"
import script from "./footer-user.vue?vue&type=script&lang=js&"
export * from "./footer-user.vue?vue&type=script&lang=js&"
import style0 from "./footer-user.vue?vue&type=style&index=0&id=faf5c618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf5c618",
  null
  
)

export default component.exports